export const descriptionRenderers = {};

function defaultDescriptionRenderer(obj) {
  return obj["TITLE_SHOW"] || obj["TITLE"] || obj["TITLE_IDX"] || obj["DESCRIPTION"] || obj["ID"]
}

export function descriptionByType(obj) {
    return (descriptionRenderers[obj["TYPE"][0]] || defaultDescriptionRenderer)(obj);
}
